import {PixiState} from 'src/Pixi';
import {Game, PlayerState} from '../Game';
import {Location} from '../../common/map/Location';
import GameConfig from '../GameConfig';
import {Point} from 'pixi.js';

interface Controller {
    showCursor(style?: string): void;
    hideCursor(): void;
    askToSpectate(): void;
    worldPointerLocation(): Location;
    enterBuildState(): void;
    exitBuildState(): void;
    isMobile: boolean;
    state: PixiState;
}

abstract class State {
    protected active: string;
    public controller: Controller;

    public start(): void {
        // To be overridden by subclasses
    }

    public finish(): void {
        // To be overridden by subclasses
    }

    public tick(): void {
        // To be overridden by subclasses
    }

    public onMouseMove(_e: Point): void {
        // To be overridden by subclasses
    }

    public onMouseClick(_e: Point): void {
        // To be overridden by subclasses
    }

    protected isSpectating(): boolean {
        return !this.player().isAlive;
    }

    protected player(): PlayerState {
        return this.game.currentPlayer;
    }

    protected get game(): Game {
        return this.controller.state.gameState;
    }

    public getCursorTile(): Location {
        return this.controller.worldPointerLocation().multN(1 / GameConfig.tileSize);
    }
}

export default State;

export interface StateCtor {
    new (): State;
}



// WEBPACK FOOTER //
// ./src/game/states/State.ts